import { createStore } from "@stencil/store";
import windowService from "../services/window-service";

export interface RouterStoreType {
  routingKeyHistory: string[];
  routingKeyPointer: number;
  animatingHistory: string[];
  animatingPointer: number;
  breakpoint: number;
  animatingBreakpoint: number;
  initialRoutingKeyHistory: string[] | null;
  initialRoutingKeyPointer: number | null;
}

export const routerStore = createStore<RouterStoreType>({
  routingKeyHistory: [],
  routingKeyPointer: -1,
  animatingPointer: -1,
  animatingHistory: [],

  breakpoint: windowService.getBreakpoint(),
  animatingBreakpoint: windowService.getBreakpoint(),

  initialRoutingKeyHistory: null,
  initialRoutingKeyPointer: null,
});
